(function () {

    'use strict';

    angular
        .module('app.contactus')
        .controller('ContactUsController', [
            'APP_CONFIG',
            'ApiService',
            '$routeParams',
            'uuid',
            'LoggerApi',
            ContactUsController
        ]);

    function ContactUsController(APP_CONFIG, apiService, $routeParams, uuid, loggerApiService) {
        var _uuid = uuid.v4();
        var cus = this;
        cus.locations = [];

        init();

        resetFields();

        function init() {
            if (angular.isDefined($routeParams.locCode) && angular.isDefined($routeParams.langCode)) {
                apiService.getLocations($routeParams.langCode).then(function (response) {
                    angular.forEach(response.data, function (value) {
                        if ($routeParams.locCode == APP_CONFIG.DEFAULT_HOME && value.locationCode != 'home') {
                            cus.locations.push(value);
                        } else if ($routeParams.locCode == value.locationCode && value.locationCode != 'home') {
                            cus.selectedLocation = value;
                        }
                    });
                });
            }
        }

        cus.isLocationClickable = function () {
            if ($routeParams.locCode === APP_CONFIG.DEFAULT_HOME) {
                return true;
            } else {
                return false;
            }
        };
        
        cus.isRichmond = function(){
            if (cus.selectedLocation == undefined){
                return false;
            }
            if(cus.selectedLocation.locationCode === 'richmond'){
                return true;
            }else{
               return false;
            }
        }
        
        cus.doSomething = function (location) {
            cus.selectedLocation = location;
        };

        cus.checkEmail = function (elementName) {
            var classes = angular.element('#' + elementName).attr('class').split(" ");
            var fve = false, fvp = false, fne = false;
            for (var i = 0; i < classes.length; i++) {
                if (classes[i] == "ng-not-empty") fne = true;
                else if (classes[i] == "ng-valid-email") fve = true;
                else if (classes[i] == "ng-valid-pattern") fvp = true;
            }

            if (fne && fve && fvp)
                angular.element('#' + elementName).removeClass("cusErrFields");
        };

        cus.checkTextFields = function (elementName) {
            var classes = angular.element('#' + elementName).attr('class').split(" ");
            var isNgPristine = false;
            for (var i = 0; i < classes.length; i++) {
                if (classes[i] == "ng-not-empty") {
                    angular.element('#' + elementName).removeClass("cusErrFields");
                    isNgPristine = true;
                } else if (classes[i] == "ng-empty") isNgPristine = true;
            }
            if (!isNgPristine) angular.element('#' + elementName).addClass("cusErrFields");
        };

        cus.customerConnectionPhone = function (location) {
            var phone = "";
            if (angular.isDefined(location) && angular.isArray(location.contacts)) {
                var contacts = location.contacts;
                for (var i = 0; contacts.length; i++) {
                    if (contacts[i].contactType == "customersupport") {
                        phone = contacts[i].phone;
                        break;
                    }
                }
            }
            return phone;
        };

        function customerConnectionEmail(location) {
            var vEmail = "";
            if (angular.isDefined(location) && angular.isArray(location.contacts)) {
                var contacts = location.contacts;
                for (var i = 0; contacts.length; i++) {
                    if (contacts[i].contactType == "customersupport") {
                        vEmail = contacts[i].email;
                        break;
                    }
                }
            }
            return vEmail;
        }

        cus.sendMessage = function (event, eventForm) {
            if (eventForm.$valid) {
                apiService.sendContactUsEmail(customerConnectionEmail(cus.selectedLocation), cus).then(
                    function (data) {
                        contactUsLogger(data, 'Success');
                        resetFields();
                        cus.submitFlag = 1;
                        loggerApiService.applicationEventStop();
                    },
                    function (data) {
                        contactUsLogger(data, 'Failed');
                        cus.submitFlag = 2;
                        loggerApiService.applicationEventStop();
                    }
                );


            } else {
                if (cus.selectedLocation == undefined) angular.element("#selectActionId").addClass("cusErrFields");
                if (cus.firstName == undefined) angular.element("#fnId").addClass("cusErrFields");
                if (cus.lastName == undefined) angular.element("#lnId").addClass("cusErrFields");
                if (cus.email == undefined) angular.element("#emailId").addClass("cusErrFields");
                if (cus.message == undefined) angular.element("#cusMessage").addClass("cusErrFields");

                if (cus.news == undefined) {
                    cus.flagNews = false;
                }
            }
        };

        function contactUsLogger(data, status) {
            loggerApiService.applicationEvent(3, "form1", "", "*", "ContactUs", "", _uuid);
            loggerApiService.applicationEventAddEvent("status", status);
            loggerApiService.applicationEventAddEvent("toEmail", "" + data.config.data.toEmail + "");
            loggerApiService.applicationEventAddEvent("firstname", "" + data.config.data.firstName + "");
            loggerApiService.applicationEventAddEvent("lastname", "" + data.config.data.lastName + "");
            loggerApiService.applicationEventStart();
        }

        cus.reset = function () {
            resetFields();
        };

        function resetFields() {
            cus.subject = undefined;
            cus.firstName = undefined;
            cus.lastName = undefined;
            cus.phoneAndAreCode = undefined;
            cus.email = undefined;
            cus.message = undefined;
            cus.news = undefined;
            cus.flagNews = true;
            cus.submitFlag = 0;
            angular.element("#selectActionId").removeClass("cusErrFields");
            angular.element("#fnId").removeClass("cusErrFields");
            angular.element("#lnId").removeClass("cusErrFields");
            angular.element("#emailId").removeClass("cusErrFields");
            angular.element("#cusMessage").removeClass("cusErrFields");
        }

        cus.checkRBValue = function () {
            cus.flagNews = true;
        }

    }

})();


// WEBPACK FOOTER //
// ./app/contactus/ContactUsController.js